module.exports = __webpack_public_path__ + "static/media/2 (8).36add3fe.jpg";